import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { AngularTokenService } from 'angular-token';
import { AuthService } from '../authentication/auth.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable({
  providedIn: 'root'
})

export class OnboardingService {

  options: any;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { this.options = this.authService.getHeaders(); }

  postCompanyDetails(param: any) {
    let url = environment.apiBaseUrl + '/api/v1/partner/onboard_post_company_details';
    return this.http.post(url, param, this.options)
  }

  getCompanyDetails() {
    let url = environment.apiBaseUrl + '/api/v1/partner/onboard_view_company_details';
    return this.http.get(url, this.options)
  }

  postCapabilityDetails(param: any) {
    let url = environment.apiBaseUrl + '/api/v1/partner/onboard_post_capabilities';
    return this.http.post(url, param, this.options)
  }

  getCapabilityDetails() {
    let url = environment.apiBaseUrl + '/api/v1/partner/onboard_view_capabilities';
    return this.http.get(url, this.options)
  }

  getDesigns() {
    let url = environment.apiBaseUrl + '/api/v1/designs';
    return this.http.get(url, this.options)
  }

  getManufacturingTechnologies() {
    let url = environment.apiBaseUrl + '/api/v1/manufacturing_technologies';
    return this.http.get(url, this.options)
  }

  getPostProcesses() {
    let url = environment.apiBaseUrl + '/api/v1/post_processes';
    return this.http.get(url, this.options)
  }

  getPrintProcesses() {
    let url = environment.apiBaseUrl + '/api/v1/print_processes';
    return this.http.get(url, this.options)
  }

  getCertificates() {
    let url = environment.apiBaseUrl + '/api/v1/certifications';
    return this.http.get(url, this.options)
  }

  completeOnboarding() {
    let url = environment.apiBaseUrl + '/api/v1/partner/complete_onboarding';
    return this.http.patch(url, { headers: this.options, observe: 'response' })
  }

  validateOnboarding() {
    let url = environment.apiBaseUrl + '/api/v1/partner/validate_onboarding';
    return this.http.get(url, this.options)
  }

  getSoftwares() {
    let url = environment.apiBaseUrl + '/api/v1/softwares';
    return this.http.get(url, this.options)
  }

  getAvailableAddresses() {
    let url = environment.apiBaseUrl + '/api/v1/partner/addresses';
    return this.http.get(url, this.options)
  }

  searchMachines(manufacturingTechnologyId, keyword) {
    let url = environment.apiBaseUrl + '/api/v1/search_machine_name?vm_name=' + keyword + '&manufacturing_technology_id=' + manufacturingTechnologyId;
    return this.http.get(url, this.options)
  }

  searchInstruments(keyword) {
    let url = environment.apiBaseUrl + '/api/v1/search_quality_instrument_name?qi_name=' + keyword;
    return this.http.get(url, this.options)
  }

  searchBrands(keyword) {
    let url = environment.apiBaseUrl + '/api/v1/search_brand_name?b_name=' + keyword;
    return this.http.get(url, this.options)
  }

  searchClients(keyword) {
    let url = environment.apiBaseUrl + '/api/v1/search_client_name?mc_name=' + keyword;
    return this.http.get(url, this.options)
  }

  sendOTP(param: any) {
    let url = environment.apiBaseUrl + '/generate_otp';
    return this.http.post(url, param, this.options)
  }

  submitOTP(param: any) {
    let url = environment.apiBaseUrl + '/verify_otp';
    return this.http.post(url, param, this.options)
  }

  getIndustries() {
    let url = environment.apiBaseUrl + '/api/v1/master_industries';
    return this.http.get(url, this.options)
  }

  getMasterSpecs(manufacturingTechnology) {
    let url = environment.apiBaseUrl + '/api/v1/master_specifications';
    return this.http.get(url, this.options)
  }

  getMachineUnits() {
    let url = environment.apiBaseUrl + '/api/v1/machine_specification_units';
    return this.http.get(url, this.options)
  }

  getVendorOwnedMachines() {
    let url = environment.apiBaseUrl + '/api/v1/partner/vendor_owned_machines';
    return this.http.get(url, this.options)
  }

  getVendorOwnedByTechnologyMachines() {
    let url = environment.apiBaseUrl + '/api/v1/partner/vendor_owned_machines/machines_by_technology';
    return this.http.get(url, this.options)
  }

  getMachineRelatedSpecs(machineId) {
    let url = environment.apiBaseUrl + '/api/v1/vendor_machines/' + machineId + '/machine_specs';
    return this.http.get(url, this.options)
  }

  removeDocument(documentId) {
    let url = environment.apiBaseUrl + '/api/v1/partner/documents/' + documentId;
    return this.http.delete(url, this.options)
  }

  removePortfolio(portfolioId) {
    let url = environment.apiBaseUrl + '/api/v1/partner/portfolio_attachments/' + portfolioId;
    return this.http.delete(url, this.options)
  }

  getInternationalCode(){
    return this.http.get('./assets/phone_number/international_code.json')
  }
  
}
